import { render, staticRenderFns } from "./Encaminhamentos.vue?vue&type=template&id=255a5f20&scoped=true"
import script from "./Encaminhamentos.vue?vue&type=script&lang=js"
export * from "./Encaminhamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a5f20",
  null
  
)

export default component.exports